import { render, staticRenderFns } from "./MonthlyEPFCIMB.vue?vue&type=template&id=60544a92"
import script from "./MonthlyEPFCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports